import Preferences from '@/sdk-mobile-web/Preferences/Preferences';
import {MatchState} from '@/services/internal/match/interfaces';
import submitScore from '@/services/internal/match/submitScore';

export default class HeartbeatManager {
  static scoreHeartbeatTimer: NodeJS.Timeout | null = null;
  static currentHeartbeatValue: any = null;
  static shouldSendHeartbeat = false;
  static matchDetails: any;
  static gid: string;
  static isCash: boolean;

  static setCurrentHeartbeatValue(value: any) {
    this.shouldSendHeartbeat = true;
    this.currentHeartbeatValue = value;
  }

  static startHeartbeatTimer(isCash: boolean, matchDetails: any, gid: string) {
    this.isCash = isCash;
    this.matchDetails = matchDetails;
    this.gid = gid;

    const status = this.statusForHeartbeat().toUpperCase();
    if (status === 'BOTH' || (isCash && status === 'CASH')) {
      const interval = this.secondsBetweenHeartbeat;

      if (interval) {
        this.currentHeartbeatValue = null;
        this.stopHeartbeatTimer(); // Clear any existing timer

        this.scoreHeartbeatTimer = setInterval(() => {
          if (this.currentHeartbeatValue) {
            this.updateScore();
          }
        }, interval * 1000); // Convert seconds to milliseconds
      }
    }
  }
  static statusForHeartbeat() {
    return Preferences.get('heartbeat.status');
  }

  static get secondsBetweenHeartbeat() {
    return Preferences.get('heartbeat.seconds');
  }
  static updateScore() {
    if (!this.currentHeartbeatValue || !this.shouldSendHeartbeat) {
      return;
    }

    submitScore({
      data: this.currentHeartbeatValue,
      state: MatchState.PENDING,
      isCash: this.isCash,
      gameId: this.gid,
      token: Buffer.from(JSON.stringify(this.matchDetails)).toString('base64'),
    });
  }

  static stopHeartbeatTimer() {
    if (this.scoreHeartbeatTimer) {
      clearInterval(this.scoreHeartbeatTimer);
      this.scoreHeartbeatTimer = null;
    }
  }
}
